import React from "react";

export default function ShowcaseCardSkeleton({ count = 4, titleLines = 1 }) {
  return (
    <div className="row shwc-pd-row" aria-busy="true" aria-label="Loading">
      {Array.from({ length: count }).map((_, index) => (
        <div className="col-lg-3 col-md-4 col-6 px-2" key={index}>
          <div className="shwc-pd-skeleton">
            <div className="shwc-pd-skeleton__image skeleton-shimmer" />
            {titleLines === 2 ? (
              <>
                <div className="shwc-pd-skeleton__line skeleton-shimmer" />
                <div className="shwc-pd-skeleton__line shwc-pd-skeleton__line--short skeleton-shimmer" />
              </>
            ) : (
              <div className="shwc-pd-skeleton__line skeleton-shimmer" />
            )}
            <div className="shwc-pd-skeleton__btn skeleton-shimmer" />
          </div>
        </div>
      ))}
    </div>
  );
}
